import { render, staticRenderFns } from "./MemorizeView.vue?vue&type=template&id=13ad1544&scoped=true&"
import script from "./MemorizeView.vue?vue&type=script&lang=js&"
export * from "./MemorizeView.vue?vue&type=script&lang=js&"
import style0 from "./MemorizeView.vue?vue&type=style&index=0&id=13ad1544&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad1544",
  null
  
)

export default component.exports